// Global-search-result row context menu (2026-08-02 per Nika "add in
// searchdropdown items pin to navbar in context menu") — right-clicking a
// NavSearchResultItem (components/NavSearchDropdown.js, rendered inside
// HeaderSearch's and IntranetAppHeader's search dropdowns) opens the house
// ContextDropdown with a single Pin/Unpin row. Same registered
// itemsFn/actionFn contract as shared/functions/navbarTabMenu.js (base tabs)
// and functions/searchAppTileMenu.js (apps-launcher tiles); `searchResult`
// rides the dropdown state so the rows know which row was targeted.
//
// A search result's route is never part of the base HEADER_TABS /
// workspaceSettings.navbar list HeaderTabs renders, so pinning one is a
// CUSTOM navbar pin (navbarTabMenu.js's `pinnedCustom`) — the SAME per-user ×
// per-workspace prefs bag the base-tab pin/remove/reorder menu already
// writes to, not a second mechanism. toggleCustomNavbarPin owns the
// toggle + persistence; applyNavbarTabPrefs (consumed by HeaderTabs) is what
// turns a pinned result into a real, visible navbar tab.
// Bare shared-library import, not a deep navbarTabMenu.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrappers, not a module-scope destructure — see app.js's circular-init note.
import _wsShared from '@symbo-ls/workspace-shared'
const shellNavbarTabPrefs = (...args) => _wsShared.functions.navbarTabPrefs(...args)
const shellToggleCustomNavbarPin = (...args) => _wsShared.functions.toggleCustomNavbarPin(...args)

// itemsFn — `el.call('navSearchResultMenuItems', root)` (this = the Menu el,
// unused here — no route classifiers needed, unlike navbarTabMenuItems).
export const navSearchResultMenuItems = function (root) {
  const cm = root && root.contextDropdown
  const result = cm && cm.searchResult
  if (!cm || !cm.open || !result || !result.path) return []
  const pinned = shellNavbarTabPrefs(root).pinnedCustom.some((c) => c.path === result.path)
  return [
    {
      key: 'pin',
      action: 'pin',
      label: pinned ? 'shell.navSearchMenu.unpin' : 'shell.navSearchMenu.pin'
    }
  ]
}

// actionFn — `el.call('navSearchResultMenuAction', action)` from
// ContextDropdownItem.onClick (this = the clicked row el). Owns the close —
// same contract as navbarTabMenuAction / searchAppTileMenuAction.
export const navSearchResultMenuAction = async function (action) {
  const root = this.state.root
  const result = root.contextDropdown?.searchResult || null
  root.update({ contextDropdown: null }, { preventFetch: true })
  if (action === 'pin' && result?.path) {
    await shellToggleCustomNavbarPin(root, result)
    // Collapse the search dropdown too — same post-action closeDropdown
    // convention searchAppTileMenuAction uses for every one of its rows. The
    // one-shot blur timer that was holding it open for this menu (see
    // HeaderSearch.js / IntranetAppHeader.js onBlur) already resolved
    // (skipped) the instant the menu opened, so nothing else will ever
    // re-check and close it; the pinned result now lives in the real navbar
    // (HeaderTabs), so retracting the transient panel surfaces that instead
    // of leaving a stale results list on screen.
    this.call('closeNavSearch')
  }
}
